import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PropositionMenuOption } from '../proposition-menu/proposition-menu.component';
import { ValueChangeEvent } from '@interfaces/form.interface';
import { NavController } from '@ionic/angular';

@Component({
  selector: 'ark-lib-proposition-comment',
  templateUrl: './proposition-comment.component.html',
  styleUrl: './proposition-comment.component.css',
})
export class PropositionCommentComponent {
  @Input() comment!: any;
  @Input() entityType!: 'problem' | 'idea' | 'solution' | 'thinkTank';

  @Output() clicked = new EventEmitter<any>();

  @Output() commented = new EventEmitter<any>();
  @Output() replied = new EventEmitter<any>();

  @Output() replyClicked = new EventEmitter<any>();

  @Output() upvoted = new EventEmitter<any>();
  @Output() downvoted = new EventEmitter<any>();
  @Output() upvotedReply = new EventEmitter<any>();
  @Output() downvotedReply = new EventEmitter<any>();

  menuOptions: PropositionMenuOption[] = [
    {
      name: 'Report illegal content',
      icon: 'report-flag',
      handler: () =>
        this.navController.navigateForward(
          `/report/${this.comment.commentId}/comment/illegal-content`,
        ),
    },
    {
      separatorName: 'Moderate',
    },
    // {
    //   name: 'Submit as inaccurate',
    //   icon: 'report-inaccurate',
    //   handler: () =>
    //     this.navController.navigateForward(
    //       `/report/${this.comment.commentId}/comment/inaccurate`,
    //     ),
    // },
    {
      name: 'Submit as inappropriate',
      icon: 'report-inappropriate',
      handler: () =>
        this.navController.navigateForward(
          `/report/${this.comment.commentId}/comment/inappropriate`,
        ),
    },
  ];

  @Output() commentReplied = new EventEmitter<void>();

  constructor(private navController: NavController) {}

  ngOnInit(): void {
    if (
      (this.entityType === 'idea' || this.entityType === 'problem')
    ) {
      this.menuOptions = [];
    }
  }

  toggleReply(event: Event) {
    event.preventDefault();
    event.stopPropagation();
    if (this.replyClicked.observed) {
      this.replyClicked.emit();
      return;
    }
  }

  onReply(event: ValueChangeEvent) {
    this.replied.emit({ value: event.value, comment: this.comment });
  }

  onUpvote(event: Event) {
    
    event.preventDefault();
    event.stopPropagation();
    if (this.comment.isMine) return;
    this.upvoted.emit(this.comment);
  }

  onDownVote(event: Event) {

    event.preventDefault();
    event.stopPropagation();
    if (this.comment.isMine) return;
    this.downvoted.emit(this.comment);
  }
}
